import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot, CanActivateChild } from '@angular/router';
import { Observable } from 'rxjs';
import { $DBManagerService } from '../_helpers/DB/DBManager.service';
import { $ILogger } from '../_helpers/Logger/ILogger';
import { $AuthManagerService } from './AuthManager.service';
import { _contains } from '../_utils/Common';
import { Constants } from '../_utils/Constants';
import { $ModalManagerService } from '../_helpers/Modals/ModalManager.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {
    urlExcept = [
        '/login',
        '/login/u',
        '/login/p'
    ];

    constructor(
        private router: Router,
        private console: $ILogger,
        private $auth: $AuthManagerService,
        private $db: $DBManagerService,
        private $modal: $ModalManagerService
    ) { }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
        return this.canActivate(childRoute, state);
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const urlNav = state.url;
        return this.callAuthservice(urlNav);
    }

    public callAuthservice(url: string): boolean {
        const authExist = this.$auth.isAuthExists(Constants.AUTH_TOKEN);
        const check = _contains(url, this.urlExcept);
        this.console.log('[Gaurd] url & check ::', url, check);
        this.console.log('Auth value Exists ::', authExist);
        let Flag =  this.$db.get(Constants.SESSSION_STORAGE, Constants.PAYMENT_FLAG);
        let entityStatus = this.$db.get(Constants.SESSSION_STORAGE, Constants.ENTITYSTATUS);
        
        const payment_flag = atob(Flag)
        
        if(payment_flag == "true" && entityStatus != "A"){
            this.$modal.errorModal({
                title: 'Entity-Payment',
                msg: "Please complete your payment for Entity to proceed with Header/Content/Consent template Registration. Please Re-login after successful payment."
              });
              this.router.navigate(['/payment-dues']);
            return false;
        }
        else{
            
           return true;

        }
      

      /*  if (authExist) {
            if (check) {
                this.router.navigate(['/']);
                return false;
            }
            return true;
        } else {
            if (check) { return true; }
            this.router.navigate(['/login']);
            this.$db.clearDB();
            return false;
        }*/
    }


}
